<template>
  <div class="pl-[20px] pr-[20px] pt-[10px]">
    <div class="h-[100%] rounded-[12px] mt-[14px]">
      <div class="grid grid-cols-4 w-[100%] gap-2">
        <div
          class="h-[136px] rounded-[32px] flex justify-between items-center pl-[24px] pr-[24px] cursor-pointer"
          @click="(tab = 1), (filter.search = '')"
          :class="
            tab == 1 ? 'bg-[#2875E9] text-[white]' : 'bg-[white] text-[#003765]'
          "
        >
          <div>
            <svg
              width="69"
              height="69"
              viewBox="0 0 69 69"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_528_14232"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="69"
                height="69"
              >
                <rect width="69" height="69" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_528_14232)">
                <path
                  d="M34.4999 61.8126C28.7949 61.8126 23.7749 59.8215 19.44 55.8392C15.105 51.8569 12.9375 46.4685 12.9375 39.6739C12.9375 35.3991 14.5658 30.7498 17.8223 25.726C21.0787 20.7021 26.0013 15.2326 32.5899 9.31756C32.8607 9.08827 33.1601 8.91098 33.4881 8.78568C33.8162 8.66033 34.1534 8.59766 34.4999 8.59766C34.8464 8.59766 35.1837 8.66033 35.5117 8.78568C35.8397 8.91098 36.1392 9.08827 36.4099 9.31756C42.9986 15.2326 47.9211 20.7021 51.1776 25.726C54.4341 30.7498 56.0624 35.3991 56.0624 39.6739C56.0624 46.4685 53.8949 51.8569 49.5599 55.8392C45.225 59.8215 40.205 61.8126 34.4999 61.8126ZM34.4999 57.5002C39.3211 57.5002 43.4014 55.8425 46.7408 52.527C50.0802 49.2115 51.7499 44.9276 51.7499 39.6752C51.7499 36.2731 50.3364 32.3799 47.5093 27.9955C44.6822 23.6111 40.3458 18.7356 34.4999 13.3689C28.6541 18.7356 24.3176 23.6111 21.4906 27.9955C18.6635 32.3799 17.2499 36.2731 17.2499 39.6752C17.2499 44.9276 18.9196 49.2115 22.259 52.527C25.5985 55.8425 29.6788 57.5002 34.4999 57.5002ZM35.2076 54.1829C35.7089 54.1349 36.1217 53.9474 36.4461 53.6202C36.7704 53.2931 36.9326 52.8986 36.9326 52.4368C36.9326 51.898 36.7558 51.471 36.4023 51.1559C36.0488 50.8407 35.5971 50.7071 35.0473 50.755C33.0827 50.8988 30.943 50.3228 28.6282 49.0273C26.3135 47.7317 24.8687 45.4786 24.2937 42.2682C24.1978 41.778 23.9924 41.3928 23.6772 41.1127C23.3621 40.8326 22.987 40.6925 22.5521 40.6925C22.0287 40.6925 21.5928 40.8888 21.2445 41.2813C20.8962 41.6739 20.7847 42.1779 20.9101 42.7935C21.6878 46.9696 23.5676 49.9551 26.5495 51.7502C29.5314 53.5452 32.4174 54.3561 35.2076 54.1829Z"
                  :fill="tab == 1 ? 'white' : '#003765'"
                />
              </g>
            </svg>
          </div>
          <div class="text-[18px] font-bold">มิเตอร์น้ำ</div>
        </div>
        <div
          class="h-[136px] rounded-[32px] flex justify-between items-center pl-[24px] pr-[24px] cursor-pointer"
          @click="(tab = 2), (filter.search = '')"
          :class="
            tab == 2 ? 'bg-[#F5D65E] text-[white]' : 'bg-[white] text-[#003765]'
          "
        >
          <div>
            <svg
              width="24"
              height="48"
              viewBox="0 0 24 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5348 38.1624L18.9486 23.8869C19.027 23.7394 19.0348 23.5874 18.9722 23.4307C18.9094 23.274 18.7997 23.1957 18.6429 23.1957H11.7905L16.0703 5.72474C16.133 5.5036 16.1017 5.29627 15.9762 5.10273C15.8508 4.9092 15.694 4.81243 15.5059 4.81243H4.42085C4.20136 4.81243 4.02107 4.89537 3.88 5.06126C3.73889 5.22715 3.66834 5.43911 3.66834 5.69714V26.9277C3.66834 27.1857 3.73889 27.3977 3.88 27.5636C4.02107 27.7295 4.20136 27.8124 4.42085 27.8124H10.5348V38.1624ZM22.7392 24.976L9.89991 46.8756C9.67104 47.27 9.38651 47.5298 9.04633 47.6552C8.70615 47.7805 8.36831 47.7805 8.03281 47.6552C7.69736 47.5298 7.41909 47.3013 7.19801 46.9696C6.97697 46.6378 6.86645 46.2361 6.86645 45.7643V32.1249H4.42085C3.20123 32.1249 2.1595 31.6171 1.29568 30.6016C0.431892 29.5862 0 28.3615 0 26.9277V5.69714C0 4.26333 0.431892 3.0387 1.29568 2.02325C2.1595 1.00775 3.20123 0.5 4.42085 0.5H16.2583C17.4686 0.5 18.4515 1.03906 19.2071 2.11719C19.9628 3.19531 20.1854 4.38863 19.875 5.69714L16.6487 18.8833H19.9879C21.3142 18.8833 22.2948 19.5716 22.9297 20.9483C23.5646 22.325 23.5011 23.6676 22.7392 24.976Z"
                :fill="tab == 2 ? 'white' : '#003765'"
              />
            </svg>
          </div>
          <div class="text-[18px] font-bold">มิเตอร์ไฟ</div>
        </div>
        <div
          class="h-[136px] rounded-[32px] flex justify-between items-center pl-[24px] pr-[24px] cursor-pointer"
          @click="(tab = 3), (filter.search = '')"
          :class="
            tab == 3 ? 'bg-[#1DC56A] text-[white]' : 'bg-[white] text-[#003765]'
          "
        >
          <div>
            <svg
              width="51"
              height="52"
              viewBox="0 0 51 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.65611 51.1586C3.48033 51.1586 2.46766 50.7338 1.61809 49.8842C0.768531 49.0346 0.34375 48.022 0.34375 46.8462V16.6586C0.34375 15.4828 0.768531 14.4701 1.61809 13.6205C2.46766 12.771 3.48033 12.3462 4.65611 12.3462H11.8438V5.15862C11.8438 3.98284 12.2685 2.97014 13.1181 2.12053C13.9677 1.27097 14.9803 0.846191 16.1561 0.846191H34.8438C36.0195 0.846191 37.0322 1.27097 37.8818 2.12053C38.7313 2.97014 39.1561 3.98284 39.1561 5.15862V23.8462H46.3438C47.5195 23.8462 48.5322 24.271 49.3818 25.1205C50.2313 25.9701 50.6561 26.9828 50.6561 28.1586V46.8462C50.6561 48.022 50.2313 49.0346 49.3818 49.8842C48.5322 50.7338 47.5195 51.1586 46.3438 51.1586H29.0938V39.6586H21.9061V51.1586H4.65611ZM4.65611 46.8462H11.8438V39.6586H4.65611V46.8462ZM4.65611 35.3462H11.8438V28.1586H4.65611V35.3462ZM4.65611 23.8462H11.8438V16.6586H4.65611V23.8462ZM16.1561 35.3462H23.3438V28.1586H16.1561V35.3462ZM16.1561 23.8462H23.3438V16.6586H16.1561V23.8462ZM16.1561 12.3462H23.3438V5.15862H16.1561V12.3462ZM27.6561 35.3462H34.8438V28.1586H27.6561V35.3462ZM27.6561 23.8462H34.8438V16.6586H27.6561V23.8462ZM27.6561 12.3462H34.8438V5.15862H27.6561V12.3462ZM39.1561 46.8462H46.3438V39.6586H39.1561V46.8462ZM39.1561 35.3462H46.3438V28.1586H39.1561V35.3462Z"
                :fill="tab == 3 ? 'white' : '#003765'"
              />
            </svg>
          </div>
          <div class="text-[18px] font-bold">ค่าส่วนกลาง</div>
        </div>
        <div
          class="h-[136px] rounded-[32px] flex justify-between items-center pl-[24px] pr-[24px] cursor-pointer"
          @click="(tab = 4), (filter.search = '')"
          :class="
            tab == 4 ? 'bg-[#5D5FEF] text-[white]' : 'bg-[white] text-[#003765]'
          "
        >
          <div>
            <template>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="69"
                height="69"
                viewBox="0 0 48 48"
              >
                <g
                  fill="none"
                  stroke="#D9D9D9"
                  stroke-linejoin="round"
                  stroke-width="4"
                >
                  <path
                    d="M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4S4 12.954 4 24s8.954 20 20 20Z"
                    :stroke="tab == 4 ? 'white' : '#003765'"
                  />
                  <path
                    stroke-linecap="round"
                    d="M24 16v16m-8-8h16"
                    :stroke="tab == 4 ? 'white' : '#003765'"
                  />
                </g>
              </svg>
            </template>
          </div>
          <div class="text-[18px] font-bold">บริการเสริม</div>
        </div>
      </div>
      <div
        class="h-[auto] bg-[white] rounded-[12px] pt-[28px] pl-[28px] pr-[28px] flex flex-col justify-end mt-[14px]"
      >
        <div>
          <div class="flex justify-between">
            <div class="flex">
              <div>
                <svg
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                  v-if="tab == 1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_721_15844"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="41"
                    height="41"
                  >
                    <rect width="41" height="41" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_721_15844)">
                    <path
                      d="M6.60148 35.1521C5.90283 35.1521 5.30109 34.8997 4.79628 34.3949C4.29147 33.8901 4.03906 33.2883 4.03906 32.5897V7.8188C4.03906 7.12015 4.29147 6.51841 4.79628 6.01357C5.30109 5.50875 5.90283 5.25635 6.60148 5.25635H17.7057C18.4043 5.25635 19.0061 5.50875 19.5109 6.01357C20.0157 6.51841 20.2681 7.12015 20.2681 7.8188V12.0897H34.3948C35.0934 12.0897 35.6952 12.3421 36.2 12.8469C36.7048 13.3517 36.9572 13.9535 36.9572 14.6521V32.5897C36.9572 33.2883 36.7048 33.8901 36.2 34.3949C35.6952 34.8997 35.0934 35.1521 34.3948 35.1521H6.60148ZM6.60148 32.5897H10.8724V28.3188H6.60148V32.5897ZM6.60148 25.7563H10.8724V21.4855H6.60148V25.7563ZM6.60148 18.923H10.8724V14.6521H6.60148V18.923ZM6.60148 12.0897H10.8724V7.8188H6.60148V12.0897ZM13.4348 32.5897H17.7057V28.3188H13.4348V32.5897ZM13.4348 25.7563H17.7057V21.4855H13.4348V25.7563ZM13.4348 18.923H17.7057V14.6521H13.4348V18.923ZM13.4348 12.0897H17.7057V7.8188H13.4348V12.0897ZM20.2681 32.5897H34.3948V14.6521H20.2681V18.923H24.0134V21.4855H20.2681V25.7563H24.0134V28.3188H20.2681V32.5897ZM27.7586 21.4855V18.923H30.321V21.4855H27.7586ZM27.7586 28.3188V25.7563H30.321V28.3188H27.7586Z"
                      fill="#003765"
                    />
                  </g>
                </svg>
                <svg
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  fill="none"
                  v-if="tab == 2"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_1189_20857"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="38"
                    height="38"
                  >
                    <rect width="38" height="38" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1189_20857)">
                    <path
                      d="M18.4678 27.0751L23.1015 19.2132C23.1447 19.132 23.149 19.0483 23.1145 18.962C23.0799 18.8757 23.0195 18.8326 22.9331 18.8326H19.1594L21.5163 9.21089C21.5509 9.0891 21.5336 8.97492 21.4645 8.86833C21.3954 8.76175 21.3091 8.70846 21.2055 8.70846H15.1007C14.9798 8.70846 14.8805 8.75414 14.8028 8.84549C14.7251 8.93685 14.6863 9.05358 14.6863 9.19569V20.8879C14.6863 21.03 14.7251 21.1467 14.8028 21.2381C14.8805 21.3294 14.9798 21.3751 15.1007 21.3751H18.4678V27.0751ZM25.189 19.813L18.1181 31.8737C17.9921 32.0909 17.8354 32.234 17.6481 32.303C17.4607 32.372 17.2746 32.372 17.0899 32.303C16.9051 32.234 16.7519 32.1081 16.6301 31.9254C16.5084 31.7427 16.4475 31.5215 16.4475 31.2617V23.7501H15.1007C14.429 23.7501 13.8553 23.4705 13.3796 22.9112C12.9039 22.352 12.666 21.6775 12.666 20.8879V9.19569C12.666 8.40605 12.9039 7.73162 13.3796 7.17239C13.8553 6.61313 14.429 6.3335 15.1007 6.3335H21.6199C22.2864 6.3335 22.8277 6.63037 23.2438 7.22412C23.66 7.81787 23.7826 8.47506 23.6116 9.19569L21.8349 16.4576H23.6739C24.4043 16.4576 24.9443 16.8367 25.294 17.5949C25.6436 18.3531 25.6086 19.0924 25.189 19.813Z"
                      fill="#003765"
                    />
                  </g>
                </svg>
                <svg
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  fill="none"
                  v-if="tab == 3"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_1295_20234"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="38"
                    height="38"
                  >
                    <rect width="38" height="38" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1295_20234)">
                    <path
                      d="M7.5214 32.5799C6.87387 32.5799 6.31617 32.3459 5.8483 31.878C5.38042 31.4101 5.14648 30.8524 5.14648 30.2049V13.5799C5.14648 12.9323 5.38042 12.3746 5.8483 11.9067C6.31617 11.4389 6.87387 11.2049 7.5214 11.2049H11.4798V7.24654C11.4798 6.59901 11.7138 6.0413 12.1816 5.57339C12.6495 5.10552 13.2072 4.87158 13.8547 4.87158H24.1465C24.794 4.87158 25.3517 5.10552 25.8196 5.57339C26.2875 6.0413 26.5214 6.59901 26.5214 7.24654V17.5383H30.4798C31.1273 17.5383 31.685 17.7722 32.1529 18.2401C32.6208 18.708 32.8547 19.2657 32.8547 19.9132V30.2049C32.8547 30.8524 32.6208 31.4101 32.1529 31.878C31.685 32.3459 31.1273 32.5799 30.4798 32.5799H20.9798V26.2465H17.0214V32.5799H7.5214ZM7.5214 30.2049H11.4798V26.2465H7.5214V30.2049ZM7.5214 23.8716H11.4798V19.9132H7.5214V23.8716ZM7.5214 17.5383H11.4798V13.5799H7.5214V17.5383ZM13.8547 23.8716H17.8132V19.9132H13.8547V23.8716ZM13.8547 17.5383H17.8132V13.5799H13.8547V17.5383ZM13.8547 11.2049H17.8132V7.24654H13.8547V11.2049ZM20.1881 23.8716H24.1465V19.9132H20.1881V23.8716ZM20.1881 17.5383H24.1465V13.5799H20.1881V17.5383ZM20.1881 11.2049H24.1465V7.24654H20.1881V11.2049ZM26.5214 30.2049H30.4798V26.2465H26.5214V30.2049ZM26.5214 23.8716H30.4798V19.9132H26.5214V23.8716Z"
                      fill="#003765"
                    />
                  </g>
                </svg>

                <svg
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  fill="none"
                  v-if="tab == 4"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_528_31570"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="38"
                    height="38"
                  >
                    <rect width="38" height="38" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_528_31570)">
                    <path
                      d="M19.0008 31.2096C17.5028 31.2096 16.2249 30.6808 15.1674 29.6232C14.1098 28.5657 13.581 27.2879 13.581 25.7898C13.581 24.2917 14.1098 23.0139 15.1674 21.9563C16.2249 20.8988 17.5028 20.37 19.0008 20.37C20.4989 20.37 21.7767 20.8988 22.8343 21.9563C23.8918 23.0139 24.4206 24.2917 24.4206 25.7898C24.4206 27.2879 23.8918 28.5657 22.8343 29.6232C21.7767 30.6808 20.4989 31.2096 19.0008 31.2096ZM19.0041 28.8347C19.8423 28.8347 20.5588 28.5362 21.1535 27.9393C21.7483 27.3424 22.0457 26.6248 22.0457 25.7866C22.0457 24.9483 21.7472 24.2318 21.1503 23.6371C20.5534 23.0423 19.8358 22.745 18.9976 22.745C18.1594 22.745 17.4429 23.0434 16.8481 23.6403C16.2534 24.2373 15.956 24.9548 15.956 25.793C15.956 26.6313 16.2544 27.3477 16.8513 27.9425C17.4483 28.5373 18.1658 28.8347 19.0041 28.8347ZM6.33733 13.6469L4.5957 12.0028C6.45913 10.1819 8.61233 8.7463 11.0553 7.69581C13.4983 6.64535 16.1468 6.12012 19.0008 6.12012C21.8549 6.12012 24.5034 6.64535 26.9464 7.69581C29.3893 8.7463 31.5425 10.1819 33.406 12.0028L31.6643 13.6469C29.9937 12.0413 28.0795 10.7812 25.9218 9.86676C23.764 8.95228 21.457 8.49504 19.0008 8.49504C16.5447 8.49504 14.2377 8.95228 12.0799 9.86676C9.92212 10.7812 8.00793 12.0413 6.33733 13.6469ZM26.5246 18.5674C25.4975 17.6154 24.3552 16.8861 23.0977 16.3797C21.8402 15.8732 20.4745 15.62 19.0008 15.62C17.5271 15.62 16.1681 15.8732 14.9238 16.3797C13.6795 16.8861 12.5306 17.6154 11.477 18.5674L9.7354 16.9232C11.0183 15.7459 12.4397 14.8385 13.9997 14.2011C15.5597 13.5637 17.2267 13.245 19.0008 13.245C20.775 13.245 22.4379 13.5637 23.9898 14.2011C25.5416 14.8385 26.959 15.7459 28.2419 16.9232L26.5246 18.5674Z"
                      fill="#003765"
                    />
                  </g>
                </svg>
              </div>
              <div
                class="text-[24px] font-bold ml-[8px] flex justify-center items-center"
              >
                {{
                  tab == 1
                    ? "มิเตอร์น้ำ"
                    : tab == 2
                    ? "มิเตอร์ไฟ"
                    : tab == 3
                    ? "ค่าส่วนกลาง"
                    : "บริการอื่นๆ"
                }}
              </div>
            </div>
            <div
              class="flex border pl-[14px] pr-[14px] rounded-[12px] cursor-pointer"
              @click="routeTo('/setting')"
            >
              <div class="flex justify-center items-center">
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.3845 18.2081H7.60814C7.40247 18.2081 7.22442 18.1391 7.074 18.001C6.92357 17.8629 6.83308 17.691 6.80253 17.4854L6.53635 15.4158C6.29073 15.3336 6.03894 15.2184 5.78097 15.0703C5.52301 14.9222 5.29236 14.7636 5.08905 14.5943L3.17464 15.4017C2.97838 15.4781 2.78359 15.4857 2.59026 15.4246C2.39693 15.3635 2.24504 15.2425 2.13456 15.0615L0.756079 12.6606C0.645605 12.4796 0.611818 12.2863 0.654718 12.0806C0.697603 11.8749 0.801897 11.7092 0.967599 11.5835L2.62466 10.3301C2.6035 10.1938 2.58851 10.0569 2.5797 9.91937C2.57088 9.78187 2.56647 9.64496 2.56647 9.50864C2.56647 9.37818 2.57088 9.24567 2.5797 9.1111C2.58851 8.97654 2.6035 8.82934 2.62466 8.66952L0.967599 7.41614C0.801897 7.2904 0.697603 7.1247 0.654718 6.91903C0.611818 6.71338 0.645605 6.52006 0.756079 6.33908L2.13456 3.95579C2.23564 3.7654 2.38372 3.642 2.5788 3.5856C2.77388 3.52919 2.96955 3.53918 3.16581 3.61557L5.08022 4.41413C5.30117 4.23901 5.5371 4.07889 5.78801 3.93375C6.03893 3.78859 6.28544 3.67195 6.52753 3.58381L6.80253 1.51427C6.83308 1.3086 6.92357 1.13673 7.074 0.998647C7.22442 0.860552 7.40247 0.791504 7.60814 0.791504H10.3845C10.5902 0.791504 10.7697 0.860552 10.9231 0.998647C11.0764 1.13673 11.1684 1.3086 11.199 1.51427L11.4651 3.59263C11.7401 3.69252 11.989 3.80916 12.2117 3.94255C12.4344 4.07594 12.6592 4.23313 12.886 4.41413L14.8357 3.61557C15.0319 3.53918 15.2252 3.53007 15.4156 3.58823C15.606 3.64641 15.7564 3.76599 15.8669 3.94697L17.2454 6.33908C17.3559 6.52006 17.3897 6.71338 17.3468 6.91903C17.3039 7.1247 17.1996 7.2904 17.0339 7.41614L15.3416 8.69594C15.3745 8.84403 15.3924 8.98242 15.3953 9.1111C15.3983 9.23979 15.3997 9.36936 15.3997 9.49981C15.3997 9.62439 15.3968 9.75102 15.3909 9.87971C15.3851 10.0084 15.3639 10.1556 15.3275 10.3213L17.0021 11.5835C17.1737 11.7034 17.2795 11.8676 17.3194 12.0762C17.3594 12.2848 17.3242 12.4796 17.2137 12.6606L15.8352 15.0474C15.7247 15.2283 15.5705 15.3503 15.3724 15.4132C15.1744 15.476 14.9773 15.4693 14.781 15.3929L12.886 14.5855C12.6592 14.7665 12.4277 14.9266 12.1914 15.0659C11.9552 15.2052 11.7131 15.3189 11.4651 15.407L11.199 17.4854C11.1684 17.691 11.0764 17.8629 10.9231 18.001C10.7697 18.1391 10.5902 18.2081 10.3845 18.2081ZM9.0113 12.2498C9.77402 12.2498 10.423 11.9821 10.9583 11.4468C11.4936 10.9115 11.7613 10.2625 11.7613 9.49981C11.7613 8.73712 11.4936 8.08811 10.9583 7.55279C10.423 7.01749 9.77402 6.74984 9.0113 6.74984C8.23921 6.74984 7.58786 7.01749 7.05725 7.55279C6.52665 8.08811 6.26135 8.73712 6.26135 9.49981C6.26135 10.2625 6.52665 10.9115 7.05725 11.4468C7.58786 11.9821 8.23921 12.2498 9.0113 12.2498ZM9.0113 10.8748C8.62936 10.8748 8.30471 10.7411 8.03735 10.4738C7.76999 10.2064 7.6363 9.88176 7.6363 9.49981C7.6363 9.11787 7.76999 8.79322 8.03735 8.52586C8.30471 8.2585 8.62936 8.12482 9.0113 8.12482C9.39325 8.12482 9.7179 8.2585 9.98526 8.52586C10.2526 8.79322 10.3863 9.11787 10.3863 9.49981C10.3863 9.88176 10.2526 10.2064 9.98526 10.4738C9.7179 10.7411 9.39325 10.8748 9.0113 10.8748ZM8.08407 16.8332H9.88567L10.2153 14.3775C10.6831 14.2553 11.1105 14.0817 11.4978 13.8566C11.885 13.6316 12.2584 13.3422 12.618 12.9884L14.8956 13.9457L15.7982 12.3873L13.8097 10.8889C13.8861 10.6515 13.9381 10.4188 13.9657 10.1908C13.9933 9.96285 14.0071 9.73251 14.0071 9.49981C14.0071 9.26125 13.9933 9.03091 13.9657 8.80879C13.9381 8.58668 13.8861 8.35986 13.8097 8.12834L15.8158 6.61232L14.9132 5.05398L12.6092 6.0253C12.3025 5.69741 11.935 5.40772 11.5066 5.15624C11.0782 4.90473 10.6449 4.72669 10.2065 4.62209L9.91741 2.16648H8.09817L7.79498 4.61327C7.32723 4.72374 6.89534 4.89298 6.49929 5.12097C6.10325 5.34896 5.72542 5.64276 5.36581 6.00239L3.08824 5.05398L2.18567 6.61232L4.16532 8.08781C4.08893 8.30521 4.03546 8.53143 4.00491 8.76648C3.97435 9.00153 3.95907 9.24892 3.95907 9.50864C3.95907 9.7472 3.97435 9.98107 4.00491 10.2102C4.03546 10.4394 4.08599 10.6656 4.1565 10.8889L2.18567 12.3873L3.08824 13.9457L5.35699 12.9831C5.70485 13.3404 6.0768 13.6331 6.47285 13.861C6.86889 14.089 7.30666 14.2641 7.78616 14.3864L8.08407 16.8332Z"
                    fill="#003765"
                  />
                </svg>
              </div>
              <div
                class="text-[14px] font-bold ml-[8px] flex justify-center items-center"
              >
                กำหนดค่า
              </div>
            </div>
          </div>
          <div class="flex justify-between">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
              <!-- <div
                                class="h-[36px] pl-[8px] pr-[8px] bg-[#003765] flex cursor-pointer  justify-center rounded-[12px] mt-[12px]">
                                <div class="flex justify-center items-center">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_528_31525" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                            y="0" width="22" height="22">
                                            <rect width="22" height="22" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_528_31525)">
                                            <path
                                                d="M4.86604 19.7084C4.403 19.7084 4.01107 19.548 3.69023 19.2272C3.3694 18.9063 3.20898 18.5144 3.20898 18.0514V5.78219C3.20898 5.31915 3.3694 4.92721 3.69023 4.60638C4.01107 4.28555 4.403 4.12513 4.86604 4.12513H6.13528V2.89114C6.13528 2.69019 6.20257 2.52243 6.33713 2.38786C6.47168 2.25331 6.63944 2.18604 6.84041 2.18604C7.04135 2.18604 7.20911 2.25331 7.34368 2.38786C7.47823 2.52243 7.54551 2.69019 7.54551 2.89114V4.12513H14.491V2.87351C14.491 2.67843 14.5568 2.51508 14.6884 2.38346C14.82 2.25184 14.9834 2.18604 15.1785 2.18604C15.3736 2.18604 15.5369 2.25184 15.6685 2.38346C15.8002 2.51508 15.866 2.67843 15.866 2.87351V4.12513H17.1352C17.5983 4.12513 17.9902 4.28555 18.311 4.60638C18.6319 4.92721 18.7923 5.31915 18.7923 5.78219V18.0514C18.7923 18.5144 18.6319 18.9063 18.311 19.2272C17.9902 19.548 17.5983 19.7084 17.1352 19.7084H4.86604ZM4.86604 18.3334H17.1352C17.2057 18.3334 17.2704 18.3041 17.3292 18.2453C17.3879 18.1865 17.4173 18.1219 17.4173 18.0514V9.44885H4.58396V18.0514C4.58396 18.1219 4.61334 18.1865 4.6721 18.2453C4.73087 18.3041 4.79552 18.3334 4.86604 18.3334ZM4.58396 8.07388H17.4173V5.78219C17.4173 5.71167 17.3879 5.64702 17.3292 5.58824C17.2704 5.52949 17.2057 5.50011 17.1352 5.50011H4.86604C4.79552 5.50011 4.73087 5.52949 4.6721 5.58824C4.61334 5.64702 4.58396 5.71167 4.58396 5.78219V8.07388ZM11.0006 12.904C10.7762 12.904 10.5849 12.8249 10.4268 12.6669C10.2688 12.5088 10.1897 12.3175 10.1897 12.0931C10.1897 11.8686 10.2688 11.6773 10.4268 11.5193C10.5849 11.3612 10.7762 11.2822 11.0006 11.2822C11.2251 11.2822 11.4164 11.3612 11.5744 11.5193C11.7325 11.6773 11.8115 11.8686 11.8115 12.0931C11.8115 12.3175 11.7325 12.5088 11.5744 12.6669C11.4164 12.8249 11.2251 12.904 11.0006 12.904ZM7.33396 12.904C7.1095 12.904 6.91824 12.8249 6.76017 12.6669C6.60211 12.5088 6.52308 12.3175 6.52308 12.0931C6.52308 11.8686 6.60211 11.6773 6.76017 11.5193C6.91824 11.3612 7.1095 11.2822 7.33396 11.2822C7.55842 11.2822 7.74968 11.3612 7.90775 11.5193C8.06581 11.6773 8.14484 11.8686 8.14484 12.0931C8.14484 12.3175 8.06581 12.5088 7.90775 12.6669C7.74968 12.8249 7.55842 12.904 7.33396 12.904ZM14.6673 12.904C14.4428 12.904 14.2516 12.8249 14.0935 12.6669C13.9354 12.5088 13.8564 12.3175 13.8564 12.0931C13.8564 11.8686 13.9354 11.6773 14.0935 11.5193C14.2516 11.3612 14.4428 11.2822 14.6673 11.2822C14.8918 11.2822 15.083 11.3612 15.2411 11.5193C15.3991 11.6773 15.4782 11.8686 15.4782 12.0931C15.4782 12.3175 15.3991 12.5088 15.2411 12.6669C15.083 12.8249 14.8918 12.904 14.6673 12.904ZM11.0006 16.5001C10.7762 16.5001 10.5849 16.4211 10.4268 16.263C10.2688 16.1049 10.1897 15.9137 10.1897 15.6892C10.1897 15.4648 10.2688 15.2735 10.4268 15.1154C10.5849 14.9574 10.7762 14.8783 11.0006 14.8783C11.2251 14.8783 11.4164 14.9574 11.5744 15.1154C11.7325 15.2735 11.8115 15.4648 11.8115 15.6892C11.8115 15.9137 11.7325 16.1049 11.5744 16.263C11.4164 16.4211 11.2251 16.5001 11.0006 16.5001ZM7.33396 16.5001C7.1095 16.5001 6.91824 16.4211 6.76017 16.263C6.60211 16.1049 6.52308 15.9137 6.52308 15.6892C6.52308 15.4648 6.60211 15.2735 6.76017 15.1154C6.91824 14.9574 7.1095 14.8783 7.33396 14.8783C7.55842 14.8783 7.74968 14.9574 7.90775 15.1154C8.06581 15.2735 8.14484 15.4648 8.14484 15.6892C8.14484 15.9137 8.06581 16.1049 7.90775 16.263C7.74968 16.4211 7.55842 16.5001 7.33396 16.5001ZM14.6673 16.5001C14.4428 16.5001 14.2516 16.4211 14.0935 16.263C13.9354 16.1049 13.8564 15.9137 13.8564 15.6892C13.8564 15.4648 13.9354 15.2735 14.0935 15.1154C14.2516 14.9574 14.4428 14.8783 14.6673 14.8783C14.8918 14.8783 15.083 14.9574 15.2411 15.1154C15.3991 15.2735 15.4782 15.4648 15.4782 15.6892C15.4782 15.9137 15.3991 16.1049 15.2411 16.263C15.083 16.4211 14.8918 16.5001 14.6673 16.5001Z"
                                                fill="white" />
                                        </g>
                                    </svg>
                                </div>
                                <div class="text-white font-bold ml-[8px]   flex justify-center items-center">พฤษภาคม/2023
                                </div>
                            </div> -->
              <div class="relative" v-if="tab != 3">
                <button
                  type="button"
                  @click="showDatePicker = !showDatePicker"
                  class="h-[36px] pl-[8px] pr-[8px] bg-[#003765] flex cursor-pointer text-[white] justify-center items-center rounded-[12px] mt-[12px]"
                >
                  {{ formatMonthYear(selectedDate) }}
                </button>
                <div
                  v-if="showDatePicker"
                  class="absolute top-full left-0 z-10 mt-1 bg-white shadow-lg rounded-lg p-4 text-[#003765]"
                >
                  <div class="flex justify-between items-center mb-2">
                    <button
                      type="button"
                      @click="changeYear(-1)"
                      class="px-2 py-1 bg-[#F3F7FA] rounded"
                    >
                      &lt;
                    </button>
                    <div class="font-bold">{{ currentYear }}</div>
                    <button
                      type="button"
                      @click="changeYear(1)"
                      class="px-2 py-1 bg-[#F3F7FA] rounded"
                    >
                      &gt;
                    </button>
                  </div>
                  <div class="grid grid-cols-3 gap-2">
                    <div
                      v-for="(month, index) in monthNames"
                      :key="index"
                      @click="selectMonth(index)"
                      class="p-2 text-center cursor-pointer rounded hover:bg-[#F3F7FA]"
                      :class="{ 'bg-[#003765] text-white': isSelectedMonth(index) }"
                    >
                      {{ month.substring(0, 3) }}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex justify-start items-center mt-[5px]">
                  <input
                    class="h-[36px] w-[250px] bg-[#F3F7FA] rounded-[12px]"
                    placeholder="ค้นหาตามหมายเลขห้อง"
                    v-model="filter.search"
                    @input="$refs.childComponentRef.filterData(filter.search)"
                    type="input"
                    @keydown="handleKeyDown"
                  />
                </div>
              </div>
              <!-- <vs-tooltip bottom shadow not-hover v-model="popup_filter">
                                <div @click="popup_filter = true" v-if="tab == 4"
                                    class="h-[36px] w-[132px]  flex  justify-center rounded-[12px] mt-[12px] ml-[14px] cursor-pointer">
                                    <div class="flex justify-center items-center">
                                        <svg width="22" height="23" viewBox="0 0 22 23" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_3354_16235" style="mask-type:alpha" maskUnits="userSpaceOnUse"
                                                x="0" y="0" width="22" height="23">
                                                <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_3354_16235)">
                                                <path
                                                    d="M10.9997 17.6875C10.8048 17.6875 10.6415 17.6216 10.5099 17.4898C10.3783 17.3581 10.3125 17.1948 10.3125 17V12.1875H5.49998C5.30519 12.1875 5.14191 12.1215 5.01016 11.9897C4.87839 11.8579 4.8125 11.6945 4.8125 11.4997C4.8125 11.3048 4.87839 11.1415 5.01016 11.0099C5.14191 10.8783 5.30519 10.8125 5.49998 10.8125H10.3125V5.99998C10.3125 5.80519 10.3784 5.6419 10.5102 5.51013C10.6421 5.37838 10.8054 5.3125 11.0003 5.3125C11.1952 5.3125 11.3584 5.37838 11.49 5.51013C11.6216 5.6419 11.6875 5.80519 11.6875 5.99998V10.8125H16.5C16.6948 10.8125 16.8581 10.8784 16.9898 11.0102C17.1216 11.1421 17.1875 11.3054 17.1875 11.5003C17.1875 11.6952 17.1216 11.8584 16.9898 11.99C16.8581 12.1216 16.6948 12.1875 16.5 12.1875H11.6875V17C11.6875 17.1948 11.6215 17.3581 11.4897 17.4898C11.3579 17.6216 11.1945 17.6875 10.9997 17.6875Z"
                                                    fill="#003765" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div class=" font-bold ml-[8px] flex justify-center items-center">กำหนดค่าบริการ</div>
                                </div>
                                <template #tooltip>
                                    <div class="w-[100%]">
                                        <div class="center">
                                            <vs-checkbox v-model="option">
                                                <div class="text-custom">ห้องค้างชำระ</div>
                                            </vs-checkbox>
                                        </div>
                                        <div class="center">
                                            <vs-checkbox v-model="option">
                                                <div class="text-custom">ห้องชำระเงินแล้ว</div>
                                            </vs-checkbox>
                                        </div>
                                        <div class="center">
                                            <vs-checkbox v-model="option">
                                                <div class="text-custom">ห้องว่าง</div>
                                            </vs-checkbox>
                                        </div>
                                        <div class="center">
                                            <vs-checkbox v-model="option">
                                                <div class="text-custom">ห้องติดจอง</div>
                                            </vs-checkbox>
                                        </div>
                                        <div class="center">
                                            <vs-checkbox v-model="option">
                                                <div class="text-custom">ห้องใกล้หมดสัญญา</div>
                                            </vs-checkbox>
                                        </div>
                                        <div class="center">
                                            <vs-checkbox v-model="option">
                                                <div class="text-custom">ห้องแจ้งย้ายออก</div>
                                            </vs-checkbox>
                                        </div>
                                    </div>
                                </template>
                            </vs-tooltip> -->
              <div class="ml-[14px]">
                <vs-tooltip bottom shadow not-hover v-model="popup_filter">
                  <div
                    @click="popup_filter = true"
                    class="h-[36px] w-[132px] flex justify-center rounded-[12px] mt-[12px] _ cursor-pointer"
                  >
                    <div class="flex justify-center items-center">
                      <svg
                        width="22"
                        height="23"
                        viewBox="0 0 22 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3262_4178"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="22"
                          height="23"
                        >
                          <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3262_4178)">
                          <path
                            d="M10.0846 16.7707C9.88982 16.7707 9.72655 16.7048 9.59479 16.573C9.46302 16.4411 9.39714 16.2778 9.39714 16.0829C9.39714 15.888 9.46302 15.7248 9.59479 15.5932C9.72655 15.4615 9.88982 15.3957 10.0846 15.3957H11.9179C12.1127 15.3957 12.276 15.4616 12.4078 15.5935C12.5395 15.7253 12.6054 15.8886 12.6054 16.0835C12.6054 16.2784 12.5395 16.4416 12.4078 16.5733C12.276 16.7049 12.1127 16.7707 11.9179 16.7707H10.0846ZM3.66795 7.25144C3.47315 7.25144 3.30988 7.18553 3.17813 7.05369C3.04635 6.92186 2.98047 6.75851 2.98047 6.56364C2.98047 6.36876 3.04635 6.20551 3.17813 6.07389C3.30988 5.94227 3.47315 5.87646 3.66795 5.87646H18.3346C18.5294 5.87646 18.6927 5.94238 18.8245 6.07421C18.9562 6.20603 19.0221 6.36938 19.0221 6.56426C19.0221 6.75913 18.9562 6.92237 18.8245 7.05399C18.6927 7.18563 18.5294 7.25144 18.3346 7.25144H3.66795ZM6.41795 12.0111C6.22315 12.0111 6.05988 11.9451 5.92813 11.8133C5.79635 11.6815 5.73047 11.5181 5.73047 11.3233C5.73047 11.1284 5.79635 10.9651 5.92813 10.8335C6.05988 10.7019 6.22315 10.6361 6.41795 10.6361H15.5846C15.7794 10.6361 15.9427 10.702 16.0745 10.8338C16.2062 10.9657 16.2721 11.129 16.2721 11.3239C16.2721 11.5188 16.2062 11.682 16.0745 11.8136C15.9427 11.9452 15.7794 12.0111 15.5846 12.0111H6.41795Z"
                            fill="#003765"
                          />
                        </g>
                      </svg>
                    </div>
                    <div
                      class="font-bold ml-[8px] flex justify-center items-center"
                    >
                      ฟิลเตอร์
                    </div>
                  </div>
                  <template #tooltip>
                    <div class="w-[100%]">
                      <div class="center">
                        <vs-checkbox v-model="option">
                          <div class="text-custom">ห้องค้างชำระ</div>
                        </vs-checkbox>
                      </div>
                      <div class="center">
                        <vs-checkbox v-model="option">
                          <div class="text-custom">ห้องชำระเงินแล้ว</div>
                        </vs-checkbox>
                      </div>
                      <div class="center">
                        <vs-checkbox v-model="option">
                          <div class="text-custom">ห้องว่าง</div>
                        </vs-checkbox>
                      </div>
                      <div class="center">
                        <vs-checkbox v-model="option">
                          <div class="text-custom">ห้องติดจอง</div>
                        </vs-checkbox>
                      </div>
                      <div class="center">
                        <vs-checkbox v-model="option">
                          <div class="text-custom">ห้องใกล้หมดสัญญา</div>
                        </vs-checkbox>
                      </div>
                      <div class="center">
                        <vs-checkbox v-model="option">
                          <div class="text-custom">ห้องแจ้งย้ายออก</div>
                        </vs-checkbox>
                      </div>
                    </div>
                  </template>
                </vs-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <div v-if="tab == 1" class="flex">
            <div>
              <input
                class="h-[28px] w-[120px] rounded-[12px] border flex justify-start"
                id="upload-water"
                hidden
                type="file"
                @change="handleFileSelected('water')"
                ref="importExcelWater"
                accept=".csv,.xlsx,.xls,.ods, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
              <label for="upload-water">
                <div
                  class="h-[36px] pl-[8px] pr-[8px] bg-[#39B974] flex cursor-pointer justify-center rounded-[12px] mt-[12px]"
                >
                  <div class="flex justify-center items-center">
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.58398 3.021C4.52321 3.021 4.46492 3.04514 4.42194 3.08812C4.37896 3.13109 4.35482 3.18938 4.35482 3.25016V6.68766H10.084C10.4637 6.68766 10.7715 6.99547 10.7715 7.37516V15.6252C10.7715 16.0049 10.4637 16.3127 10.084 16.3127H4.35482V19.7502C4.35482 19.8109 4.37896 19.8692 4.42194 19.9122C4.46492 19.9552 4.5232 19.9793 4.58398 19.9793H17.4173C17.4781 19.9793 17.5364 19.9552 17.5794 19.9122C17.6223 19.8692 17.6465 19.8109 17.6465 19.7502V3.25016C17.6465 3.18938 17.6223 3.13109 17.5794 3.08812C17.5364 3.04514 17.4781 3.021 17.4173 3.021H4.58398ZM2.97982 16.3127V19.7502C2.97982 20.1756 3.14883 20.5836 3.44967 20.8845C3.75051 21.1853 4.15853 21.3543 4.58398 21.3543H17.4173C17.8428 21.3543 18.2508 21.1853 18.5516 20.8845C18.8525 20.5836 19.0215 20.1756 19.0215 19.7502V3.25016C19.0215 2.82471 18.8525 2.41669 18.5516 2.11585C18.2508 1.81501 17.8428 1.646 17.4173 1.646H4.58398C4.15853 1.646 3.75051 1.81501 3.44967 2.11585C3.14883 2.41668 2.97982 2.82471 2.97982 3.25016V6.68766H1.83398C1.45429 6.68766 1.14648 6.99547 1.14648 7.37516V15.6252C1.14648 16.0049 1.45429 16.3127 1.83398 16.3127H2.97982ZM3.66616 14.9377C3.66655 14.9377 3.66693 14.9377 3.66732 14.9377C3.6677 14.9377 3.66809 14.9377 3.66848 14.9377H9.39649V8.06266H3.66732H2.52148V14.9377H3.66616ZM13.5215 7.37516C13.5215 6.99547 13.8293 6.68766 14.209 6.68766H15.584C15.9637 6.68766 16.2715 6.99547 16.2715 7.37516C16.2715 7.75486 15.9637 8.06266 15.584 8.06266H14.209C13.8293 8.06266 13.5215 7.75486 13.5215 7.37516ZM12.1465 11.0418C12.1465 10.6621 12.4543 10.3543 12.834 10.3543H15.584C15.9637 10.3543 16.2715 10.6621 16.2715 11.0418C16.2715 11.4215 15.9637 11.7293 15.584 11.7293H12.834C12.4543 11.7293 12.1465 11.4215 12.1465 11.0418ZM12.1465 14.7085C12.1465 14.3288 12.4543 14.021 12.834 14.021H15.584C15.9637 14.021 16.2715 14.3288 16.2715 14.7085C16.2715 15.0882 15.9637 15.396 15.584 15.396H12.834C12.4543 15.396 12.1465 15.0882 12.1465 14.7085ZM5.07012 9.63903C4.80163 9.37054 4.36633 9.37054 4.09785 9.63903C3.82936 9.90751 3.82936 10.3428 4.09785 10.6113L4.98671 11.5002L4.09785 12.389C3.82936 12.6575 3.82936 13.0928 4.09785 13.3613C4.36633 13.6298 4.80163 13.6298 5.07012 13.3613L5.95898 12.4724L6.84785 13.3613C7.11633 13.6298 7.55163 13.6298 7.82012 13.3613C8.08861 13.0928 8.08861 12.6575 7.82012 12.389L6.93126 11.5002L7.82012 10.6113C8.08861 10.3428 8.08861 9.90751 7.82012 9.63903C7.55163 9.37054 7.11633 9.37054 6.84785 9.63903L5.95898 10.5279L5.07012 9.63903Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    class="text-white font-bold ml-[8px] flex justify-center items-center"
                  >
                    นำเข้ามิเตอร์น้ำ+ไฟฟ้าผ่าน Excel
                  </div>
                </div>
              </label>
            </div>
            <div>
              <label class="ml-[14px]">
                <div
                  class="h-[36px] pl-[8px] pr-[8px] bg-[#39B974] flex cursor-pointer justify-center rounded-[12px] mt-[12px]"
                >
                  <div class="flex justify-center items-center">
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.58398 3.021C4.52321 3.021 4.46492 3.04514 4.42194 3.08812C4.37896 3.13109 4.35482 3.18938 4.35482 3.25016V6.68766H10.084C10.4637 6.68766 10.7715 6.99547 10.7715 7.37516V15.6252C10.7715 16.0049 10.4637 16.3127 10.084 16.3127H4.35482V19.7502C4.35482 19.8109 4.37896 19.8692 4.42194 19.9122C4.46492 19.9552 4.5232 19.9793 4.58398 19.9793H17.4173C17.4781 19.9793 17.5364 19.9552 17.5794 19.9122C17.6223 19.8692 17.6465 19.8109 17.6465 19.7502V3.25016C17.6465 3.18938 17.6223 3.13109 17.5794 3.08812C17.5364 3.04514 17.4781 3.021 17.4173 3.021H4.58398ZM2.97982 16.3127V19.7502C2.97982 20.1756 3.14883 20.5836 3.44967 20.8845C3.75051 21.1853 4.15853 21.3543 4.58398 21.3543H17.4173C17.8428 21.3543 18.2508 21.1853 18.5516 20.8845C18.8525 20.5836 19.0215 20.1756 19.0215 19.7502V3.25016C19.0215 2.82471 18.8525 2.41669 18.5516 2.11585C18.2508 1.81501 17.8428 1.646 17.4173 1.646H4.58398C4.15853 1.646 3.75051 1.81501 3.44967 2.11585C3.14883 2.41668 2.97982 2.82471 2.97982 3.25016V6.68766H1.83398C1.45429 6.68766 1.14648 6.99547 1.14648 7.37516V15.6252C1.14648 16.0049 1.45429 16.3127 1.83398 16.3127H2.97982ZM3.66616 14.9377C3.66655 14.9377 3.66693 14.9377 3.66732 14.9377C3.6677 14.9377 3.66809 14.9377 3.66848 14.9377H9.39649V8.06266H3.66732H2.52148V14.9377H3.66616ZM13.5215 7.37516C13.5215 6.99547 13.8293 6.68766 14.209 6.68766H15.584C15.9637 6.68766 16.2715 6.99547 16.2715 7.37516C16.2715 7.75486 15.9637 8.06266 15.584 8.06266H14.209C13.8293 8.06266 13.5215 7.75486 13.5215 7.37516ZM12.1465 11.0418C12.1465 10.6621 12.4543 10.3543 12.834 10.3543H15.584C15.9637 10.3543 16.2715 10.6621 16.2715 11.0418C16.2715 11.4215 15.9637 11.7293 15.584 11.7293H12.834C12.4543 11.7293 12.1465 11.4215 12.1465 11.0418ZM12.1465 14.7085C12.1465 14.3288 12.4543 14.021 12.834 14.021H15.584C15.9637 14.021 16.2715 14.3288 16.2715 14.7085C16.2715 15.0882 15.9637 15.396 15.584 15.396H12.834C12.4543 15.396 12.1465 15.0882 12.1465 14.7085ZM5.07012 9.63903C4.80163 9.37054 4.36633 9.37054 4.09785 9.63903C3.82936 9.90751 3.82936 10.3428 4.09785 10.6113L4.98671 11.5002L4.09785 12.389C3.82936 12.6575 3.82936 13.0928 4.09785 13.3613C4.36633 13.6298 4.80163 13.6298 5.07012 13.3613L5.95898 12.4724L6.84785 13.3613C7.11633 13.6298 7.55163 13.6298 7.82012 13.3613C8.08861 13.0928 8.08861 12.6575 7.82012 12.389L6.93126 11.5002L7.82012 10.6113C8.08861 10.3428 8.08861 9.90751 7.82012 9.63903C7.55163 9.37054 7.11633 9.37054 6.84785 9.63903L5.95898 10.5279L5.07012 9.63903Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    class="text-white font-bold ml-[8px] flex justify-center items-center cursor-pointer"
                    @click="downloadTemplate()"
                  >
                    ดาวน์โหลดเทมเพลต Excel
                  </div>
                </div>
              </label>
              <div class="text-[11px] text-[#8396A6] mt-[2px]">
                รองรับไฟล์ .xlsx .xls .csv - ไฟล์ Numbers ให้ Export เป็น Excel/CSV ก่อน
              </div>
            </div>
          </div>
          <div v-else-if="tab == 2">
            <input
              class="h-[28px] w-[120px] rounded-[12px] border flex justify-start"
              id="upload-electric"
              hidden
              type="file"
              @change="handleFileSelected('electric')"
              ref="importExcelElectric"
              accept=".csv,.xlsx,.xls,.ods, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <label for="upload-electric">
              <div
                class="h-[36px] pl-[8px] pr-[8px] bg-[#39B974] flex cursor-pointer justify-center rounded-[12px] mt-[12px]"
              >
                <div class="flex justify-center items-center">
                  <svg
                    width="22"
                    height="23"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.58398 3.021C4.52321 3.021 4.46492 3.04514 4.42194 3.08812C4.37896 3.13109 4.35482 3.18938 4.35482 3.25016V6.68766H10.084C10.4637 6.68766 10.7715 6.99547 10.7715 7.37516V15.6252C10.7715 16.0049 10.4637 16.3127 10.084 16.3127H4.35482V19.7502C4.35482 19.8109 4.37896 19.8692 4.42194 19.9122C4.46492 19.9552 4.5232 19.9793 4.58398 19.9793H17.4173C17.4781 19.9793 17.5364 19.9552 17.5794 19.9122C17.6223 19.8692 17.6465 19.8109 17.6465 19.7502V3.25016C17.6465 3.18938 17.6223 3.13109 17.5794 3.08812C17.5364 3.04514 17.4781 3.021 17.4173 3.021H4.58398ZM2.97982 16.3127V19.7502C2.97982 20.1756 3.14883 20.5836 3.44967 20.8845C3.75051 21.1853 4.15853 21.3543 4.58398 21.3543H17.4173C17.8428 21.3543 18.2508 21.1853 18.5516 20.8845C18.8525 20.5836 19.0215 20.1756 19.0215 19.7502V3.25016C19.0215 2.82471 18.8525 2.41669 18.5516 2.11585C18.2508 1.81501 17.8428 1.646 17.4173 1.646H4.58398C4.15853 1.646 3.75051 1.81501 3.44967 2.11585C3.14883 2.41668 2.97982 2.82471 2.97982 3.25016V6.68766H1.83398C1.45429 6.68766 1.14648 6.99547 1.14648 7.37516V15.6252C1.14648 16.0049 1.45429 16.3127 1.83398 16.3127H2.97982ZM3.66616 14.9377C3.66655 14.9377 3.66693 14.9377 3.66732 14.9377C3.6677 14.9377 3.66809 14.9377 3.66848 14.9377H9.39649V8.06266H3.66732H2.52148V14.9377H3.66616ZM13.5215 7.37516C13.5215 6.99547 13.8293 6.68766 14.209 6.68766H15.584C15.9637 6.68766 16.2715 6.99547 16.2715 7.37516C16.2715 7.75486 15.9637 8.06266 15.584 8.06266H14.209C13.8293 8.06266 13.5215 7.75486 13.5215 7.37516ZM12.1465 11.0418C12.1465 10.6621 12.4543 10.3543 12.834 10.3543H15.584C15.9637 10.3543 16.2715 10.6621 16.2715 11.0418C16.2715 11.4215 15.9637 11.7293 15.584 11.7293H12.834C12.4543 11.7293 12.1465 11.4215 12.1465 11.0418ZM12.1465 14.7085C12.1465 14.3288 12.4543 14.021 12.834 14.021H15.584C15.9637 14.021 16.2715 14.3288 16.2715 14.7085C16.2715 15.0882 15.9637 15.396 15.584 15.396H12.834C12.4543 15.396 12.1465 15.0882 12.1465 14.7085ZM5.07012 9.63903C4.80163 9.37054 4.36633 9.37054 4.09785 9.63903C3.82936 9.90751 3.82936 10.3428 4.09785 10.6113L4.98671 11.5002L4.09785 12.389C3.82936 12.6575 3.82936 13.0928 4.09785 13.3613C4.36633 13.6298 4.80163 13.6298 5.07012 13.3613L5.95898 12.4724L6.84785 13.3613C7.11633 13.6298 7.55163 13.6298 7.82012 13.3613C8.08861 13.0928 8.08861 12.6575 7.82012 12.389L6.93126 11.5002L7.82012 10.6113C8.08861 10.3428 8.08861 9.90751 7.82012 9.63903C7.55163 9.37054 7.11633 9.37054 6.84785 9.63903L5.95898 10.5279L5.07012 9.63903Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  class="text-white font-bold ml-[8px] flex justify-center items-center"
                >
                  นำเข้ามิเตอร์น้ำ+ไฟฟ้าผ่าน Excel
                </div>
              </div>
            </label>
            <label class="ml-[14px]">
              <div
                class="h-[36px] pl-[8px] pr-[8px] bg-[#39B974] flex cursor-pointer justify-center rounded-[12px] mt-[12px]"
              >
                <div class="flex justify-center items-center">
                  <svg
                    width="22"
                    height="23"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.58398 3.021C4.52321 3.021 4.46492 3.04514 4.42194 3.08812C4.37896 3.13109 4.35482 3.18938 4.35482 3.25016V6.68766H10.084C10.4637 6.68766 10.7715 6.99547 10.7715 7.37516V15.6252C10.7715 16.0049 10.4637 16.3127 10.084 16.3127H4.35482V19.7502C4.35482 19.8109 4.37896 19.8692 4.42194 19.9122C4.46492 19.9552 4.5232 19.9793 4.58398 19.9793H17.4173C17.4781 19.9793 17.5364 19.9552 17.5794 19.9122C17.6223 19.8692 17.6465 19.8109 17.6465 19.7502V3.25016C17.6465 3.18938 17.6223 3.13109 17.5794 3.08812C17.5364 3.04514 17.4781 3.021 17.4173 3.021H4.58398ZM2.97982 16.3127V19.7502C2.97982 20.1756 3.14883 20.5836 3.44967 20.8845C3.75051 21.1853 4.15853 21.3543 4.58398 21.3543H17.4173C17.8428 21.3543 18.2508 21.1853 18.5516 20.8845C18.8525 20.5836 19.0215 20.1756 19.0215 19.7502V3.25016C19.0215 2.82471 18.8525 2.41669 18.5516 2.11585C18.2508 1.81501 17.8428 1.646 17.4173 1.646H4.58398C4.15853 1.646 3.75051 1.81501 3.44967 2.11585C3.14883 2.41668 2.97982 2.82471 2.97982 3.25016V6.68766H1.83398C1.45429 6.68766 1.14648 6.99547 1.14648 7.37516V15.6252C1.14648 16.0049 1.45429 16.3127 1.83398 16.3127H2.97982ZM3.66616 14.9377C3.66655 14.9377 3.66693 14.9377 3.66732 14.9377C3.6677 14.9377 3.66809 14.9377 3.66848 14.9377H9.39649V8.06266H3.66732H2.52148V14.9377H3.66616ZM13.5215 7.37516C13.5215 6.99547 13.8293 6.68766 14.209 6.68766H15.584C15.9637 6.68766 16.2715 6.99547 16.2715 7.37516C16.2715 7.75486 15.9637 8.06266 15.584 8.06266H14.209C13.8293 8.06266 13.5215 7.75486 13.5215 7.37516ZM12.1465 11.0418C12.1465 10.6621 12.4543 10.3543 12.834 10.3543H15.584C15.9637 10.3543 16.2715 10.6621 16.2715 11.0418C16.2715 11.4215 15.9637 11.7293 15.584 11.7293H12.834C12.4543 11.7293 12.1465 11.4215 12.1465 11.0418ZM12.1465 14.7085C12.1465 14.3288 12.4543 14.021 12.834 14.021H15.584C15.9637 14.021 16.2715 14.3288 16.2715 14.7085C16.2715 15.0882 15.9637 15.396 15.584 15.396H12.834C12.4543 15.396 12.1465 15.0882 12.1465 14.7085ZM5.07012 9.63903C4.80163 9.37054 4.36633 9.37054 4.09785 9.63903C3.82936 9.90751 3.82936 10.3428 4.09785 10.6113L4.98671 11.5002L4.09785 12.389C3.82936 12.6575 3.82936 13.0928 4.09785 13.3613C4.36633 13.6298 4.80163 13.6298 5.07012 13.3613L5.95898 12.4724L6.84785 13.3613C7.11633 13.6298 7.55163 13.6298 7.82012 13.3613C8.08861 13.0928 8.08861 12.6575 7.82012 12.389L6.93126 11.5002L7.82012 10.6113C8.08861 10.3428 8.08861 9.90751 7.82012 9.63903C7.55163 9.37054 7.11633 9.37054 6.84785 9.63903L5.95898 10.5279L5.07012 9.63903Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  class="text-white font-bold ml-[8px] flex justify-center items-center cursor-pointer"
                  @click="downloadTemplate()"
                >
                  ดาวน์โหลดเทมเพลต Excel
                </div>
              </div>
            </label>
            <div class="text-[11px] text-[#8396A6] mt-[2px]">
              รองรับไฟล์ .xlsx .xls .csv - ไฟล์ Numbers ให้ Export เป็น Excel/CSV ก่อน
            </div>
          </div>
        </div>
        <b-modal
          centered
          v-model="importPreview.open"
          size="l"
          hide-backdrop
          hide-header-close
          hide-header
          hide-footer
          class="text-custom"
        >
          <div>
            <div class="flex justify-between">
              <div class="text-custom flex justify-center items-center text-[16px] font-bold">
                ยืนยันนำเข้ามิเตอร์น้ำและไฟฟ้า
              </div>
              <div @click="cancelImport()" class="cursor-pointer">✕</div>
            </div>
            <div class="text-[13px] text-[#8396A6] mt-[4px]">
              {{ importPreview.fileName }}
            </div>
            <div v-if="importPreview.error" class="mt-[14px] text-[#EA5455]">
              {{ importPreview.error }}
            </div>
            <template v-else>
              <div class="mt-[14px] max-h-[320px] overflow-y-auto">
                <vs-table :data="importRowsToImport">
                  <template #thead>
                    <vs-tr>
                      <vs-th>เลขห้อง</vs-th>
                      <vs-th>เลขมิเตอร์น้ำ</vs-th>
                      <vs-th>เลขมิเตอร์ไฟฟ้า</vs-th>
                    </vs-tr>
                  </template>
                  <template #tbody>
                    <vs-tr :key="i" v-for="(row, i) in importRowsToImport" :data="row">
                      <vs-td>{{ row.roomnumber || "(ตามลำดับในไฟล์)" }}</vs-td>
                      <vs-td>{{ row.waterunit ?? "-" }}</vs-td>
                      <vs-td>{{ row.electricunit ?? "-" }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <div class="text-[13px] text-[#8396A6] mt-[8px]">
                นำเข้า {{ importRowsToImport.length }} ห้อง
                <span v-if="importPreview.skipped">
                  · ข้าม {{ importPreview.skipped }} แถวที่ไม่มีเลขมิเตอร์
                </span>
              </div>
            </template>
            <div class="flex justify-end mt-[20px]">
              <vs-button dark shadow @click="cancelImport()">ยกเลิก</vs-button>
              <div class="ml-[12px]">
                <vs-button
                  :disabled="!!importPreview.error || importRowsToImport.length === 0"
                  @click="confirmImport()"
                >
                  ยืนยันนำเข้า
                </vs-button>
              </div>
            </div>
          </div>
        </b-modal>
        <div class="flex items-center mb-[8px] mt-[14px] table-container">
          <!-- <div v-for="(data, i) in floor " class="flex-initial flex-nowrap w-32 p-2 border-1 rounded-t-lg" -->
          <div
            v-for="(data, i) in floor"
            class="flex-initial flex-nowrap w-32 p-2 border-1"
            :class="
              tab_floor == i
                ? 'font-bold text-[16px] text-[white] bg-[#003765]'
                : 'text-[#8396A6]'
            "
          >
            <div
              class="cursor-pointer mr-[8px] whitespace-nowrap"
              :class="
                tab_floor == i ? 'font-bold text-[16px]' : 'text-[#8396A6]'
              "
              @click="selectFloor(data, i)"
            >
              ชั้น {{ data.attributes.floorName }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="tab == 1">
        <Water :id="filter.floor" :tab="name_floor" ref="childComponentRef" />
      </div>
      <div v-if="tab == 2">
        <Electricity
          :id="filter.floor"
          :tab="name_floor"
          ref="childComponentRef"
        />
      </div>
      <div v-if="tab == 3">
        <CommonFee
          :id="filter.floor"
          :tab="name_floor"
          ref="childComponentRef"
        />
      </div>
      <div v-if="tab == 4">
        <OtherFees
          :id="filter.floor"
          :tab="name_floor"
          ref="childComponentRef"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Water from "./components/Water.vue";
import Electricity from "./components/Electricity.vue";
import CommonFee from "./components/CommonFee.vue";
import OtherFees from "./components/OtherFees.vue";
import axios from "axios";
import { authHeaders } from "@/utils/authHeaders";
import * as XLSX from "xlsx";

// Excel column headers - match the grid's own column labels (Water.vue /
// Electricity.vue) instead of internal English field names, so the sheet
// reads the same as the screen it came from. One file/template now covers
// both water and electric - the water and electric tabs' import/template
// buttons both drive this same combined sheet.
const COL_ROOM = "เลขห้อง";
const COL_WATER = "เลขมิเตอร์น้ำเดือนล่าสุด";
const COL_ELECTRIC = "เลขมิเตอร์ไฟฟ้าเดือนล่าสุด";

export default {
  components: { Water, Electricity, CommonFee, OtherFees },
  data() {
    return {
      tab: 1,
      popup_filter: false,
      filter: {
        search: "",
        floor: "",
        selectedMonth: "",
        selectedYear: "",
      },
      floor: [],
      tab_floor: "0",
      name_floor: "",
      selectedDate: null,
      showDatePicker: false,
      currentYear: new Date().getFullYear(),
      monthNames: [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
        "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
      ],
      importPreview: {
        open: false,
        tab: null,
        file: null,
        fileName: "",
        rows: [],
        skipped: 0,
        error: null,
      },
    };
  },
  computed: {
    // Rows with a value to actually write - what the preview table shows
    // and what "confirm" is enabled/disabled on. importPreview.rows itself
    // stays the full, original-order array (including blank rows) because
    // the backend resolves a blank roomnumber by position in that array.
    importRowsToImport() {
      return this.importPreview.rows.filter(
        (r) => r.waterunit != null || r.electricunit != null
      );
    },
  },
  created() {
    this.selectedDate = new Date().toISOString().substr(0, 7); // Set the default to current month
    this.currentYear = parseInt(this.selectedDate.split("-")[0], 10);
    this.$store.state.main = true;
    const loading = this.$vs.loading({
      opacity: 1,
    });
    this.getfloor();
    setTimeout(() => {
      loading.close();
    }, 1000);
  },
  methods: {
    getFloorStorageKey() {
      return `mainMeterSelectedFloor_${this.$store.state.building}`;
    },
    toArabicDigits(value) {
      const thaiDigits = "๐๑๒๓๔๕๖๗๘๙";
      return String(value || "").replace(/[๐-๙]/g, (digit) =>
        thaiDigits.indexOf(digit)
      );
    },
    extractFloorNumber(floorName) {
      const normalized = this.toArabicDigits(floorName);
      const match = normalized.match(/-?\d+(\.\d+)?/);
      return match ? Number(match[0]) : Number.POSITIVE_INFINITY;
    },
    sortFloorsByName(floors) {
      return [...(floors || [])].sort((a, b) => {
        const aName = a?.attributes?.floorName || "";
        const bName = b?.attributes?.floorName || "";
        const numDiff =
          this.extractFloorNumber(aName) - this.extractFloorNumber(bName);
        if (numDiff !== 0) {
          return numDiff;
        }
        return aName.localeCompare(bName, "th", {
          numeric: true,
          sensitivity: "base",
        });
      });
    },
    selectFloor(floorData, index) {
      this.tab_floor = index;
      this.filter.floor = floorData.id;
      this.name_floor = floorData.attributes.floorName;
      localStorage.setItem(this.getFloorStorageKey(), String(floorData.id));
      this.callChildFunction(floorData.id);
    },
    routeTo(path) {
      this.$router.push({
        path: path + "?tab=3",
      });
    },
    filterByDate() {
      const dateStr = this.selectedDate;
      const [a, b] = dateStr.split("-");
      this.filter.selectedMonth = b;
      this.filter.selectedYear = a;
      this.callChildFunction(
        this.filter.floor,
        this.filter.selectedMonth,
        this.filter.selectedYear
      );
    },
    changeYear(amount) {
      this.currentYear += amount;
    },
    selectMonth(monthIndex) {
      const month = String(monthIndex + 1).padStart(2, "0");
      this.selectedDate = `${this.currentYear}-${month}`;
      this.filterByDate();
      this.showDatePicker = false;
    },
    isSelectedMonth(monthIndex) {
      if (!this.selectedDate) return false;
      const [year, month] = this.selectedDate.split("-");
      return (
        parseInt(year, 10) === this.currentYear &&
        parseInt(month, 10) === monthIndex + 1
      );
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const [year, month] = dateString.split("-");
      return `${this.monthNames[parseInt(month, 10) - 1]} ${year}`;
    },
    callChildFunction(id) {
      if (this.tab == 1) {
        this.$refs.childComponentRef.getWaterFee(
          id,
          this.filter.selectedMonth,
          this.filter.selectedYear
        );
      }
      if (this.tab == 2) {
        this.$refs.childComponentRef.getElectricityFee(
          id,
          this.filter.selectedMonth,
          this.filter.selectedYear
        );
      }
      if (this.tab == 3) {
        this.$refs.childComponentRef.getCommonFeeRoom(id);
      }
      if (this.tab == 4) {
        this.$refs.childComponentRef.getOtherFee(
          id,
          this.filter.selectedMonth,
          this.filter.selectedYear
        );
      }
    },
    handleKeyDown(event) {
      // Check if the pressed key is the backspace key
      if (event.keyCode === 8) {
        this.$refs.childComponentRef.filterData(this.filter.search, 8);
        // Perform your desired action here when backspace is pressed
      }
    },
    // callChildFunctionEle(id) {
    //     this.$refs.childComponentRefEle
    // },
    // callChildFunctionEle(id) {
    //     this.$refs.childComponentRefEle.getElectricityFee(id);
    // },
    getfloor() {
      // const loading = this.$vs.loading()
      fetch(
        "https://api.resguru.app/api" +
          "/building-floors?filters[building][id][$eq]=" +
          this.$store.state.building +
          "&populate=deep,2"
      )
        .then((response) => response.json())
        .then((resp) => {
          console.log("Return from getRoomFloor()", resp.data);
          this.floor = this.sortFloorsByName(resp.data);
          const savedFloorId = localStorage.getItem(this.getFloorStorageKey());
          const preferredFloorId = this.filter.floor || savedFloorId;
          const selectedFloor =
            this.floor.find(
              (item) => String(item.id) === String(preferredFloorId)
            ) || this.floor[0];
          if (selectedFloor) {
            this.filter.floor = selectedFloor.id;
            this.name_floor = selectedFloor.attributes.floorName;
            this.tab_floor = this.floor.findIndex(
              (item) => String(item.id) === String(selectedFloor.id)
            );
            localStorage.setItem(
              this.getFloorStorageKey(),
              String(selectedFloor.id)
            );
          }
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลชั้น');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          this.filterByDate();
          // this.callChildFunctionEle(this.filter.floor)
        });
    },

    resetImportInput(type) {
      const ref = type === "water" ? "importExcelWater" : "importExcelElectric";
      if (this.$refs[ref]) {
        this.$refs[ref].value = "";
      }
    },
    resetImportPreview() {
      this.importPreview = {
        open: false,
        tab: null,
        file: null,
        fileName: "",
        rows: [],
        skipped: 0,
        error: null,
      };
    },
    handleFileSelected(type) {
      const ref = type === "water" ? "importExcelWater" : "importExcelElectric";
      const file = this.$refs[ref].files[0];
      if (!file) return;

      this.importPreview = {
        open: true,
        tab: type,
        file,
        fileName: file.name,
        rows: [],
        skipped: 0,
        error: null,
      };

      // Native Apple Numbers bundles aren't a real xlsx/csv - SheetJS will
      // fail to parse one below, but give a specific pointer instead of the
      // generic "can't read this file" message.
      if (/\.numbers$/i.test(file.name)) {
        this.importPreview.error =
          "ไฟล์ Numbers (.numbers) ไม่รองรับโดยตรง กรุณาเปิดไฟล์ใน Numbers แล้ว Export เป็น Excel (.xlsx) หรือ CSV ก่อนนำเข้า";
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const workbook = XLSX.read(new Uint8Array(e.target.result), {
            type: "array",
          });
          if (!workbook.SheetNames.includes("Sheet1")) {
            this.importPreview.error =
              'ไม่พบชีทชื่อ "Sheet1" ในไฟล์ กรุณาใช้เทมเพลตที่กำหนด';
            return;
          }
          const rawRows = XLSX.utils.sheet_to_json(workbook.Sheets["Sheet1"]);
          if (rawRows.length === 0) {
            this.importPreview.error = "ไม่พบข้อมูลในไฟล์";
            return;
          }
          // Keep every row, in original sheet order - the backend resolves a
          // blank roomnumber by the row's POSITION in this array (matching
          // the template's floor+room order), so filtering here would shift
          // indices and misassign rooms. A row with neither unit filled in is
          // just skipped server-side (that room isn't being read this
          // cycle); a row can have only one of the two units filled in and
          // still import that one. Read by the Thai headers (what the
          // template actually has), with the old English keys as a fallback
          // so a hand-built or older file still works.
          let skipped = 0;
          const rows = rawRows.map((row, i) => {
            const roomnumber = row[COL_ROOM] ?? row.roomnumber ?? null;
            const rawWater = row[COL_WATER] ?? row.waterunit;
            const rawElectric = row[COL_ELECTRIC] ?? row.electricunit;
            const waterunit = rawWater == null || rawWater === "" ? null : rawWater;
            const electricunit = rawElectric == null || rawElectric === "" ? null : rawElectric;
            if (waterunit == null && electricunit == null) {
              skipped++;
              return { roomnumber, waterunit: null, electricunit: null };
            }
            if (waterunit != null && typeof waterunit !== "number") {
              throw { __rowError: `เลขมิเตอร์น้ำต้องเป็นตัวเลขที่แถว ${i + 1}` };
            }
            if (electricunit != null && typeof electricunit !== "number") {
              throw { __rowError: `เลขมิเตอร์ไฟฟ้าต้องเป็นตัวเลขที่แถว ${i + 1}` };
            }
            return { roomnumber, waterunit, electricunit };
          });
          this.importPreview.rows = rows;
          this.importPreview.skipped = skipped;
        } catch (err) {
          this.importPreview.error =
            err && err.__rowError
              ? err.__rowError
              : "ไม่สามารถอ่านไฟล์นี้ได้ กรุณาตรวจสอบรูปแบบไฟล์";
        }
      };
      reader.onerror = () => {
        this.importPreview.error = "ไม่สามารถอ่านไฟล์นี้ได้";
      };
      reader.readAsArrayBuffer(file);
    },
    cancelImport() {
      this.resetImportInput(this.importPreview.tab);
      this.resetImportPreview();
    },
    confirmImport() {
      if (!this.importPreview.file || this.importPreview.error) return;
      if (this.importRowsToImport.length === 0) return;

      const tab = this.importPreview.tab;
      const successMessage = "นำเข้ามิเตอร์น้ำและไฟฟ้าผ่าน Excel สำเร็จ";

      // Send the already-parsed rows as JSON (client-side SheetJS already
      // read the file - xlsx/xls/csv/ods all land here the same way, the
      // backend never has to know or care what format the original file
      // was). rows stays the FULL original-order array (blank rows
      // included) so the backend's row-position fallback lines up with the
      // same order the template was generated in. One combined endpoint
      // handles both services regardless of which tab's button was used.
      axios
        .put(`https://api.resguru.app/api/importCombinedMeter`, {
          building: String(this.$store.state.building),
          month: this.filter.selectedMonth,
          year: this.filter.selectedYear,
          rows: this.importPreview.rows,
        }, authHeaders())
        .then((resp) => {
          if (resp.data && resp.data.error) {
            console.error("import error:", resp.data.error);
            this.$showNotification(
              "danger",
              "นำเข้าข้อมูลไม่สำเร็จ กรุณาตรวจสอบไฟล์และลองใหม่อีกครั้ง"
            );
            return;
          }
          this.$showNotification("#3A89CB", successMessage);
          this.filterByDate();
        })
        .catch((error) => {
          console.error("import request failed:", error);
          this.$showNotification(
            "danger",
            "นำเข้าข้อมูลไม่สำเร็จ กรุณาตรวจสอบไฟล์และลองใหม่อีกครั้ง"
          );
        })
        .finally(() => {
          this.resetImportInput(tab);
          this.resetImportPreview();
        });
    },
    // Builds the template client-side from the same room list the grid
    // already uses - every room of every floor, floor-sorted the same way
    // the floor tabs are, with this month's unit pre-filled if it's been
    // read. Row order here is exactly what import's blank-roomnumber
    // position fallback resolves against (both come from getOrderedRooms
    // on the backend).
    // Same combined template regardless of which tab's button triggered
    // this - one file covers both water and electric.
    downloadTemplate() {
      axios
        .get(`https://api.resguru.app/api/getcombinedmetertemplate`, {
          params: {
            buildingid: this.$store.state.building,
            month: this.filter.selectedMonth,
            year: this.filter.selectedYear,
          },
        })
        .then((resp) => {
          if (resp.data && resp.data.error) {
            throw new Error(resp.data.error);
          }
          const rows = (resp.data.data || []).map((r) => ({
            [COL_ROOM]: r.roomnumber,
            [COL_WATER]: r.waterunit,
            [COL_ELECTRIC]: r.electricunit,
          }));
          const ws = XLSX.utils.json_to_sheet(rows, {
            header: [COL_ROOM, COL_WATER, COL_ELECTRIC],
          });
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          const label = `${this.filter.selectedYear}-${this.filter.selectedMonth}`;
          XLSX.writeFile(wb, `meter-${label}.xlsx`);
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, "สร้างเทมเพลต");
          this.$showNotification("danger", errorMessage);
        });
    },
  },
};
</script>
<style>
tbody tr:nth-child(odd) {
  background-color: #c3d4f1;
  border-radius: solid !important;
}
tbody tr:nth-child(even) {
  background-color: #e3e5e9;
  border-radius: solid !important;
}
th {
  font-size: 16px;
}
tbody td:first-child {
  font-size: 14px;
  width: 100;
}
tbody td {
  font-size: 14px;
}

.table-container {
  width: 100%;
  /* Set a fixed height to enable scrolling */
  overflow-y: scroll;
  padding: 8px;
  /* Enable vertical scrolling */
  /* Optional: Add padding for spacing */
}
</style>
